import { FC } from 'react';

import Head from 'next/head';
// import Script from 'next/script';
import { useRouter } from 'next/router';

// import { useChatbot } from './hooks';

interface MetaInfoProps {
  title?: string;
  description?: string;
  canonical?: string;
  showChatbot?: boolean;
  visitedLinks?: string[];
}
const MetaInfo: FC<MetaInfoProps> = ({
  title,
  description,
  canonical,
  visitedLinks = [],
}) => {
  const router = useRouter();

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='referrer' content='origin' />
        <meta name='description' content={description} />
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        {/\?/.test(router.asPath) ? (
          <meta name='robots' content='noindex' />
        ) : null}
        {!visitedLinks.length && canonical ? (
          <link rel='canonical' href={canonical} />
        ) : null}
        {visitedLinks.map((visitedLink) => (
          <link key={visitedLink} href={visitedLink} />
        ))}
      </Head>
    </>
  );
};

export default MetaInfo;
